import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

  export const createVehicule = async (data) => {
      try {
        const response = await api.create(`/vehicles/add`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getVehicules = async () => {
      try {
        const response = await api.get(`/vehicles/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateVehicule = async ( id, data) => {
      try {
        const response = await api.put(`/vehicles/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteVehicule = async (id) => {
    try {
        const response = await api.delete(`/vehicles/delete/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };

  export const affectVehicle = async (driverId, vehicleId) => {
    try {
      const response = await api.put(`/vehicles/assign/user/${driverId}/vehicle/${vehicleId}`);
      return response;
    } catch (error) {
        throw error;
    }
  };

  export const unassignVehicle = async (userId, vehicleId) => {
    try {
      const response = await api.put(`/vehicles/unassign/user/${userId}/vehicle/${vehicleId}`);
      return response;
    } catch (error) {
        throw error;
    }
  };

  export const getVehicleHistory = async (vehicleId) => {
    try {
      const response = await api.get(`/history/vehicles/${vehicleId}`);
      return response;
    } catch (error) {
      throw error;
    }
};
